export const defaultFilters = {
    context: undefined,
    // deliverableIdPrefix: '',
    releaseState: 'all',
    baseSoftwareVersion: 'all',
    // mdmcAppVersion: '0.0.0'
};
